import { call, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  setDueDate as setCardDueDate
} from '../redux/cards'

export default function * requestChangeCardDueDate (action) {
  const { id, dueDate } = action.payload

  const state = yield select()

  const vCard = state['view-myboard'].cards[id]

  if (!vCard) return

  const optimisticAction = yield optimisticPut(setCardDueDate({
    id,
    dueDate
  }))

  try {
    yield call(apiAction, 'SetDueDate', {
      cardId: vCard.cardId,
      timestamp: dueDate
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}
